import React, { useEffect, useState } from 'react';
import './Loader.css'; // Asegúrate de crear un archivo CSS para los estilos

export default function Loader({ onLoaded }) {
  const [progress, setProgress] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [showLoader, setShowLoader] = useState(true); // Nuevo estado para controlar la visibilidad del loader
  const [isButtonActive, setIsButtonActive] = useState(false); // Nuevo estado para controlar la activación del botón

  const steps = [
    { video: './videos/video1.mp4', text: 'Welcome to the game! Help the wizard find 16 books to save his magical world. These books contain his secret magical spells.' },
    { video: './videos/video2.mp4', text: 'Run through the forest and find the 16 sacred books... You only have 5 minutes to do it.' },
    { video: './videos/video3.mp4', text: 'Use the arrows in your keyboard to move, space bar to jump and fly and shift to run' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => prev + 10);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const stepInterval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % steps.length);
    }, 8000); // Cambia de video y texto cada 8 segundos

    return () => clearInterval(stepInterval);
  }, [steps.length]);

  useEffect(() => {
    if (progress >= 100) {
      setIsButtonActive(true); // Activa el botón cuando el progreso llegue al 100%
    }
  }, [progress]);

  const handleStartGame = () => {
    if (isButtonActive) {
      setShowLoader(false); // Oculta el loader
      onLoaded(); // Llama a la función onLoaded para mostrar el juego
    }
  };

  return (
    showLoader && (
      <div className="loader">
        <video src={steps[currentStep].video} autoPlay loop muted className="loader-video" />
        <p className="loader-text">{steps[currentStep].text}</p>
        <div className="loader-progress">
          <div className="loader-progress-bar" style={{ width: `${progress}%` }}></div>
        </div>
        <button
          className={`startGame ${isButtonActive ? 'active' : ''}`}
          onClick={handleStartGame}
          disabled={!isButtonActive} // Desactiva el botón si no está activo
        >
          Start Game
        </button>
      </div>
    )
  );
}
